import { createSelector } from '@reduxjs/toolkit';

import { selectWorkplaceCount } from 'shared/selectors/jsonQuery';

import { selectWorkplaceCountLabel } from './selectWorkplaceCountLabel';

export const selectWorkplaceCountFilter = createSelector(
  [selectWorkplaceCount, selectWorkplaceCountLabel],
  ({ gte = null, lte = null }, label) => ({
    label,
    value: { min: gte ?? null, max: lte ?? null },
  }),
);
